import { GenericBladeInitParam, GenericBladeType } from '@commblades/commblades';

export type SubLoanPurposeRaw = {
    id: number;
    data?: {
        id: number;
        description: string;
    }[];
    content?: string;
}
export type DropdownOption = {
    value: string;
    key: string;
}

export type SubLoanPurposeContent = {
    heading: string;
    description: string;
    dropDownLabelText: string;
    form1:{
        label?: string;
        dropdownOptions?:DropdownOption[];
    };
    confirmButtonText: string;
    validations:{
        errorMessage: string;
        hardValidations?:{
            form1?: {
                defaultErrorMessage?: string;
            }
        }
    }
}

const { applicationRoot } = window.NetBank;

const subLoanPurposeState: GenericBladeInitParam = {
    id: 'sub-loanpurpose',
    genericBladeType: GenericBladeType.dropdown,
    urlFetchEndPoint: `${applicationRoot}getsubloanpurposes`,
    content: {
        heading: '{heading}',
        form1: {
            label: '{label 1}',
            showFormDivider: false,
            dropdownOptions: [
                {
                    value: '{value 1 placeholder 1}',
                    key: '{label 1 placeholder 1}',
                },
                {
                    value: '{value 2 placeholder 1}',
                    key: '{label 2 placeholder 1}',
                },
            ],
        },
        confirmButtonText: '{confirmButtonText}',
    },
};

export default subLoanPurposeState;
